import { Stack } from '@mui/material';
import { NodeToolbar } from '@xyflow/react';

import { GroupNodeNameField } from './NameField';
import { GroupNodeUngroupButton } from './UngroupButton';
import { useReactFlowTransformState } from '../../../../lib/useReactFlowTransformState';
import { type ReactFlowGroupNodeProps } from '../../BlockType/types';
import { DecorationColorMenu } from '../Toolbar/ColorMenu';
import { FLOW_DECORATION_COLORS } from '../constants';

const MINIMUM_TOOLBAR_ZOOM_LEVEL = 0.3;

export function GroupNodeToolbar(props: ReactFlowGroupNodeProps) {
  const { id: nodeId, data, selected } = props;
  const { reactFlowZoomLevel } = useReactFlowTransformState();

  return (
    <NodeToolbar
      nodeId={nodeId}
      isVisible={selected && reactFlowZoomLevel > MINIMUM_TOOLBAR_ZOOM_LEVEL}
      className="nowheel nodrag nopan"
      offset={8}
    >
      <Stack
        direction="row"
        style={{
          gap: 1,
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: 4,
          paddingRight: 4,
          backgroundColor: 'white',
          border: '1px solid',
          borderRadius: 8,
          borderColor: FLOW_DECORATION_COLORS[data.color].borderColor,
        }}
      >
        {reactFlowZoomLevel > MINIMUM_TOOLBAR_ZOOM_LEVEL && (
          <>
            <DecorationColorMenu nodeId={nodeId} color={data.color} />
            <GroupNodeNameField nodeId={nodeId} label={data.label} />
          </>
        )}
        <GroupNodeUngroupButton nodeId={nodeId} />
      </Stack>
    </NodeToolbar>
  );
}
